import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-03/task-01";

const task: Slide = {
  title: "In general, speed of sound increases if ...",
  description: "Select the correct answer(s):",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
